import FaqPage from '@/components/feature/FaqPage';

export default function BpQ3Page() {
  return (
    <FaqPage
      category="Billing & Payments"
      categoryPath="/"
      icon="ri-alert-line"
      title="I was unaware of the charges"
      intro="Get help with charges you weren't aware of or didn't authorize. We take all such concerns seriously and will work to resolve them quickly."
      sections={[
        {
          heading: 'Why might I have been charged without knowing?',
          content: [
            'This can happen for several reasons: a free trial that converted to a paid subscription, an annual renewal you may have forgotten about, or a subscription purchased by someone with access to your account.',
            'We send renewal reminder emails 7 days before any charge is made. Please check your inbox, including spam folders, for these notifications.',
          ],
        },
        {
          heading: 'I didn\'t sign up for a subscription',
          content: [
            'If you believe a subscription was created without your knowledge, this may indicate unauthorized access to your account. Please change your password immediately and contact our support team.',
            'We will investigate the account activity and, if confirmed, cancel the subscription and issue a full refund.',
          ],
        },
        {
          heading: 'How do I stop future charges?',
          content: [
            'To prevent future charges, log in to your account and cancel any active subscriptions under Account Settings > Subscription. You can also disable auto-renewal to prevent future billing cycles.',
            'If you are unable to access your account, contact our support team and we will assist you in cancelling and securing your account.',
          ],
        },
        {
          heading: 'What if I want a refund for charges I was unaware of?',
          content: [
            'We review all such requests on a case-by-case basis. Please submit a Dispute Resolution Form or contact our support team with details of the charges in question.',
            'We aim to resolve all disputes fairly and promptly, typically within 5–7 business days.',
          ],
        },
      ]}
    />
  );
}
